import { Box, Typography } from "@mui/material";
import React, { useState } from "react";
import { useEffect } from "react";
import {
  getAllUserArea,
  getModulesInArea,
  getUserInArea,
  putAddUesersModule,
} from "../../../api/area";
import AddAccont from "../../../assets/SVG/addAccont";
import CustomizedHook from "../../project/autocomplatePro";
import ButtonNextLevel from "../../signin/buttonNextLevel";

export default function LevelFourArea({ level, setLevel, areaId }) {
  const [selected, setSelected] = useState({});
  const [data, setData] = useState({});
  const [modules, setModules] = useState();
  const [userArea, setUserArea] = useState();
  const [indexModule, setIndexModule] = useState(0);
  // const dataModule = [
  //   { text: "نوبت دهی", category: "nobat" },
  //   { text: "غربالگری", category: "qarbal" },
  //   // "پزشک عمومی",
  //   // "بینایی سنجی",
  //   // "شنوایی سنجی",
  // ];
  const arrNumber = [
    "یک",
    "دو",
    "سه",
    "چهار",
    "پنج",
    "شش",
    "هفت",
    "هشت",
    "نه",
    "ده",
    "یازده",
  ];
  useEffect(() => {
    if (areaId) {
      getUserInArea(areaId)
        .then((x) => setUserArea(x))
        .catch(() => {});
    }
  }, [areaId]);
  useEffect(() => {
    getModulesInArea(areaId)
      .then((x) => {
        let obj = {};
        let data = x.map((d) => {
          obj[d.id] = d.users.map((user) => user.id);
          return { ...d, text: d.moduleName };
        });
        setSelected(data[indexModule]);
        console.log(data);
        // setIndexModule(0);
        setData(obj);
        setModules(data);
      })
      .catch(() => {});
  }, []);
  console.log(modules);
  // console.log(data[selected.category]);
  // console.log(userArea);

  return (
    <>
      <Box height="55vh">
        <Box display="flex" py="10px" sx={{ overflow: "auto" }} gap="25px">
          {modules?.map((x, i) => (
            <Typography
              // onClick={() => setSelected(x)}
              fontWeight={x.id === selected.id ? "bold" : ""}
              sx={{
                cursor: "pointer",
                transition: "0.3s all",
                minWidth: "fit-content",
              }}
              color={
                x.id === selected.id ? "var(--emr-darkblue)" : "var(--emr-gray)"
              }
            >
              {x.text}
            </Typography>
          ))}
        </Box>
        <Box display="flex" gap="10px" mt="30px" flexWrap={"wrap"}>
          {Object.keys(data)?.map((x, i) => (
            <>
              {selected?.id === x &&
                data[selected?.id]?.map((z, index) => (
                  <>
                    <CustomizedHook
                      multiple
                      placeholder={`جهادگر را انتخاب کنید`}
                      label={`${selected.text} ${arrNumber[index]}`}
                      options={userArea}
                      value={
                        userArea?.find(
                          (x) => x.id === data[selected?.id][index]
                        ) || null
                      }
                      onChange={(event, newValue) => {
                        setData((z) => {
                          let array = { ...z };
                          array[selected?.id][index] = newValue.id;
                          // setUserArea((data) => {
                          //   return data.map((z, i) =>
                          //     z.id === newValue.id ? delete data[i] : { ...z }
                          //   );
                          // });
                          // console.log(data);
                          return array;
                        });
                      }}
                    />
                  </>
                ))}
            </>
          ))}
          <Box
            sx={{ cursor: "pointer", zIndex: "2" }}
            display="flex"
            alignItems="center"
            gap="10px"
            onClick={() => {
              if (userArea.length >= data[selected?.id]?.length + 1) {
                setData((y) => {
                  let array = { ...y };
                  array[selected?.id] = [...array[selected?.id], ""];
                  return array;
                });
              }
            }}
          >
            <AddAccont color="var(--emr-darkblue)" />
            <Typography
              color="var(--emr-darkblue)"
              fontWeight="bold"
              fontSize="13px"
            >
              اضافه کردن کاربر جدید به این بخش
            </Typography>
          </Box>
        </Box>
      </Box>
      <Box
        display="flex"
        justifyContent={indexModule === 0 ? "end" : "space-between"}
      >
        {indexModule !== 0 && (
          <Box
            sx={{
              width: "fit-content",
              bgcolor: "var(--emr-darkblue)",
              color: "white",
              p: "5px 10px",
              borderRadius: "5px",
              cursor: "pointer",
            }}
            onClick={() => {
              // Object.keys(data).map((key) => {
              //   if (data[key].length > 0 && key === modules[indexModule]?.id) {
              //     putAddUesersModule(areaId, key, data[key]).then(() => {
              //       //  setLevel(5);
              setSelected(modules[indexModule - 1]);
              setIndexModule(indexModule - 1);
              // console.log(key);
              // console.log(data[key]);
              // console.log(data);
              //     });
              //   }
              // });
            }}
          >
            ماژول قبلی
          </Box>
        )}
        {modules?.length > indexModule + 1 && (
          <Box
            sx={{
              width: "fit-content",
              bgcolor: "var(--emr-darkblue)",
              color: "white",
              p: "5px 10px",
              borderRadius: "5px",
              cursor: "pointer",
            }}
            onClick={() => {
              Object.keys(data).map((key) => {
                if (data[key].length > 0 && key === modules[indexModule]?.id) {
                  putAddUesersModule(areaId, key, data[key]).then(() => {
                    //  setLevel(5);
                    setSelected(modules[indexModule + 1]);
                    setIndexModule(indexModule + 1);

                    // // console.log(indexModule);
                    // console.log(modules?.length);
                    // console.log(data[key]);
                    // console.log(data);
                  });
                }
              });
            }}
          >
            ماژول بعدی
          </Box>
        )}
      </Box>
      <Box display="flex" justifyContent={"end"}>
        <ButtonNextLevel
          setLevel={setLevel}
          level={level}
          onClickNextLevel={() => {
            Object.keys(data).map((key) => {
              if (data[key].length > 0) {
                putAddUesersModule(areaId, key, data[key]).then(() => {
                  setLevel(5);
                  // console.log(key);
                  // console.log(data[key]);
                  // console.log(data);
                });
              }
            });
          }}
        />
      </Box>
    </>
  );
}
